"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remValueToPx = void 0;
const remValueRegexp = /^(\d+)?\.?\d+rem$/;
function remValueToPx(value, remInPx) {
    if (remValueRegexp.test(value.trim())) {
        const number = parseFloat(value);
        return isNaN(number) ? value : `${number * remInPx}px`;
    }
    return value;
}
exports.remValueToPx = remValueToPx;
